import { Typography } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ImageOrInitials from "../../Components/Functionality/ImageOrInitials";
import NoData from "../../Components/Functionality/NoData";
import BasicButton from "../../Components/UI/Buttons/BasicButton";
import Container from "../../Components/UI/Container";
import { ThreeDotMenu } from "../../Components/UI/Menus/ThreeDotMenu";
import { useUserStore } from "../../Context/store";
import { useProfile } from "../../Context/openProfileContext";
import { useWorkspaceStore } from "../../Context/store";
import { useAddFollowing } from "../../Web-Hooks/Profile/use-following";
import { useGetOtherUserDetailsById } from "../../Web-Hooks/Profile/use-profile";
import UserDebates from "./UserDebates";
import ShareDebate from "../Posts/ShareDebate";

const UserProfile = () => {
  const location = useLocation();
  const { pathname } = location;
  const otherUserId = pathname?.split("/")?.pop();
  const { selectedWorkspace } = useWorkspaceStore();
  const { data: user, isLoading: isUserLoading } = useGetOtherUserDetailsById(
    otherUserId,
    selectedWorkspace?.workSpaceId
  );
  const [following, setFollowing] = useState(user?.isFollowing);
  const { mutate: handleFollow } = useAddFollowing();
  const { user: loggedInUser } = useUserStore();
  const { setOpenRight } = useProfile();
  const [userData, setUserData] = useState(null);
  const [shareUserPopup, setShareUserPopup] = useState(false);
  useEffect(() => {
    setFollowing(user?.isFollowing);
  }, [user]);

  if (!user && !isUserLoading) {
    return <NoData message={"User not exist"} />;
  }

  const handleFollowing = (e, followingId) => {
    e.stopPropagation();
    handleFollow({
      Type: !following ? "follow" : "unfollow",
      FollowingUserId: followingId,
      FollowerUserId: loggedInUser?.userId,
      IsFollow: true,
    });
    setFollowing(!following);
  };
  return (
    <Container>
      <div className="w-full h-full flex justify-center">
        <div className="w-[90%] md:w-[75%] h-full grid grid-rows-[auto_1fr] gap-y-7">
          <div className="flex flex-col md:flex-row justify-start gap-3 sm:gap-10 items-center md:items-end">
            <div className="flex flex-col gap-3">
              <ImageOrInitials
                imageSrc={user?.userImage ? user?.userImage : null}
                initials={user?.userName || user?.email}
                size={"h-32 w-32"}
                classNameInitials={
                  "ring-4 text-7xl ring-primary ring-offset-[3px]"
                }
                classNameImage={"ring-4 ring-primary ring-offset-[3px]"}
              />
              <Typography className="text-2xl sm:w-32 text-center font-semibold">
                {user?.userName || " "}
              </Typography>
            </div>

            <div className="flex flex-col gap-5 justify-end w-max">
              <div className="flex gap-10">
                {" "}
                <div className="flex flex-col gap-2 items-center">
                  <Typography className="text-xl font-semibold">
                    {user?.followersCount || 0}
                  </Typography>
                  <Typography className="text-xl font-semibold">
                    Followers
                  </Typography>
                </div>
                <div className="flex flex-col gap-2 items-center">
                  <Typography className="text-xl font-semibold">
                    {user?.followingsCount || 0}
                  </Typography>
                  <Typography className="text-xl font-semibold">
                    Followings
                  </Typography>
                </div>
              </div>
              <div className="flex items-center gap-3">
                {user?.userId !== loggedInUser?.userId ? (
                  <div className="flex gap-2 w-full">
                    <BasicButton
                      variant={"filled"}
                      color={"primary"}
                      onClick={(e) => handleFollowing(e, user?.userId)}
                      className="flex-grow justify-center text-debatePalette-title"
                      isDisable={isUserLoading}
                    >
                      {following || user?.isFollowing ? "Unfollow" : "Follow"}
                    </BasicButton>
                    {/* <BasicButton
                      variant={"filled"}
                      color={"secondary"}
                      onClick={(e) => handleFollowing(e, user?.userId)}
                      className="flex-grow justify-center bg-sideLayoutSecondary text-debatePalette-background"
                    >
                      {"Message"}
                    </BasicButton> */}
                  </div>
                ) : (
                  <BasicButton
                    color={"primary"}
                    onClick={(e) => setOpenRight(true)}
                    className="flex-grow justify-center text-debatePalette-title"
                    isDisable={isUserLoading}
                  >
                    View Profile
                  </BasicButton>
                )}
                <div className="lg:hidden">
                  <ThreeDotMenu
                    otherUser={user}
                    debateId={null}
                    type={"user"}
                    setDebate={setUserData}
                    setShareDebatePopup={setShareUserPopup}
                  />
                </div>
              </div>
            </div>
            <div className="lg:flex flex-col hidden justify-center w-max">
              <ThreeDotMenu
                otherUser={user}
                debateId={null}
                type={"user"}
                setDebate={setUserData}
                setShareDebatePopup={setShareUserPopup}
              />
            </div>
          </div>
          <div className="h-full">
          <UserDebates otherUserId={otherUserId} />
          </div>
        </div>
      </div>
      <ShareDebate shareDebatePopup={shareUserPopup} type="profile" setShareDebatePopup={setShareUserPopup} debate={userData} setDebate={setUserData} />
    </Container>
  );
};

export default UserProfile;
